var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#unionpayCardProcessingModal .modal-body[data-v-10cf6233] {\n  height: 75vh;\n  overflow-y: auto;\n}\n\n#card_page .page[data-v-10cf6233] {\n  position: absolute;\n  height: 100%;\n  width: 94.4%;\n  border: 1px #666;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "UPay",
  props: ["callback_url", "request_type"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      due_amount: null,
      merId: null,
      trxtime: null,
      loader: null,
      iframe: null,
      iframeDoc: null,
      error: false
    };
  },

  mounted: function mounted() {
    var _this = this;

    $("#unionpayCardProcessingModal").on("hidden.bs.modal", function () {
      if (this.error == false) {
        var card = document.getElementById("card_pagev2");
        var c = $("#card_pagev2").find("iframe")[0];
        card.removeChild(c);
      }
      this.iframe = null;
      this.iframeDoc = null;
      this.destroyTimer();
    });

    this.invoice_number = this.$attrs["invoice_no"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.url = this.$attrs["status_api_url"];
    this.logo = this.$attrs["logo"];
    this.mpgs_url = this.$attrs["mpgs_url"];
    this.merId = this.$attrs["merchant_id"];
    this.trxtime = this.$attrs["trxtime"];
    this.loader = this.$attrs["loader"];
    this.calculate_due();

    $("#unionpayCardProcessingModal").on("shown.bs.modal", function () {
      _this.load_union_pay();
    });
  },
  methods: {
    destroyTimer: function destroyTimer() {
      this.$refs.timer.destroyTimer();
    },

    calculate_due: function calculate_due(event) {
      var flAmnt = parseFloat(this.invoice_amount);
      var flFee = parseFloat(this.fee);
      var agFee = parseFloat(this.agent_fee);
      this.due_amount = (flAmnt + flFee + agFee) * 100;
    },

    load_union_pay: function load_union_pay(e) {
      var _this2 = this;

      $("#card_pagev2").show();

      this.iframe = document.createElement("iframe");

      document.getElementById("card_pagev2").appendChild(this.iframe);
      this.iframe.setAttribute("style", "width:100%;");

      this.iframe.style.height = document.getElementById("card_pagev2").scrollHeight + 25 + "px";

      var data = {
        txnTime: this.trxtime,
        txnAmt: this.due_amount,
        merId: this.merId,
        orderId: this.invoice_number + "PN",
        currency: this.currency
      };
      var options = {
        headers: { "Content-Type": "application/json" }
      };
      Vue.axios.post(this.mpgs_url, data, options).then(function (response) {
        if (_this2.iframe.contentWindow) {
          _this2.iframeDoc = _this2.iframe.contentWindow;
        } else if (_this2.iframe.contentDocument.document) {
          _this2.iframeDoc = _this2.iframe.contentDocument.document;
        } else if (_this2.iframe.contentDocument) {
          _this2.iframeDoc = _this2.iframe.contentDocument;
        } else {
          _this2.error = true;
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "We are unable to process this payment at this time. Try other payment options provided"
          });
          return;
        }

        _this2.iframeDoc.document.open();
        _this2.iframeDoc.document.write(response.data);
        _this2.iframeDoc.document.close();
      }).catch(function (error) {});
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"unionpayCardProcessingModal",staticClass:"modal fade",attrs:{"id":"unionpayCardProcessingModal","aria-labelledby":"unionpayCardProcessingModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-xl modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center",attrs:{"id":"option_buttons"}},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":_vm.destroyTimer}},[_vm._v("Cancel")]),_vm._v(" "),_c('complete-button',{ref:"timer",attrs:{"gateway":"unionpay","status_api_url":_vm.url,"invoice_no":_vm.invoice_number,"callback_url":_vm.callback_url}})],1)])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"modal-title",attrs:{"id":"unionpayCardProcessingModal"}},[_vm._v("\n            Processing your payment, please wait...\n          ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('span',[_vm._v("Do not close this window until your payment processing is\n            complete.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"card_pagev2"}}),_vm._v(" "),_c('br')])}]
__vue__options__._scopeId = "data-v-10cf6233"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-10cf6233", __vue__options__)
  } else {
    hotAPI.reload("data-v-10cf6233", __vue__options__)
  }
})()}